import { Guid } from '@Shared.Angular/@types/guid';
import angular from 'angular';
import { IFormattedCategory } from './start.flows.formatter';

/**
 * @deprecated Don't use this interface, it's a mess. Should not have name & text, or items & flowmodels
 */
export interface ICategorySource<T> {
  name?: string | null;
  id: Guid;
  flowModels?: T[];
  subCategories?: ICategorySource<T>[];
  text?: string;
  items?: ICategorySource<T>[];
}

export interface ITreeCategory<T> {
  id: string;
  flowModels: T[];
  items: ITreeCategory<T>[];
  text: string;
}
export class RunnerCategoryNavigationService {
  getFormattedReportTreeData = <T>(data: ICategorySource<T>[]) => {
    const formattedData: ITreeCategory<T>[] = [];
    data.forEach((category) => {
      const formattedCategory = {
        items: [],
        id: category.id,
        text: category.name,
        flowModels: category.flowModels
      };

      if (category.subCategories?.length > 0) {
        formattedCategory.items = this.getFormattedReportTreeData(
          category.subCategories
        );
      }

      formattedData.push(formattedCategory);
    });

    return formattedData;
  };

  /**
   * @deprecated Use convertToTreeViewCompatibleCategories.
   * We should not be mutating the input data like this!!
   */
  getFormattedTreeData = <T>(data: ICategorySource<T>[]) => {
    data.forEach((category) => {
      category.items = category.subCategories;
      delete category.subCategories;
      category.text = category.name;
      delete category.name;

      if (category.items?.length > 0) {
        category.items = this.getFormattedTreeData(category.items);
      }
    });
    return data;
  };

  convertToTreeViewCompatibleCategories = <T>(
    categories: IFormattedCategory<T>[]
  ): ITreeCategory<T>[] => {
    return categories.map((category) => {
      return {
        id: category.id,
        text: category.name,
        flowModels: category.flowModels || [],
        items: category.subCategories
          ? this.convertToTreeViewCompatibleCategories(category.subCategories)
          : []
      };
    });
  };

  getFlowModelsFromNestedCategories<T>(categories: ITreeCategory<T>[]) {
    const allFlowModels: T[] = [];

    function extractFlowModels(categories: ITreeCategory<T>[]) {
      categories.forEach((category) => {
        if (category.flowModels?.length > 0) {
          allFlowModels.push(...category.flowModels);
        }
        if (category.subCategories?.length > 0) {
          extractFlowModels(category.subCategories);
        }
        if (category.items?.length > 0) {
          extractFlowModels(category.items);
        }
      });
    }

    extractFlowModels(categories);
    return allFlowModels;
  }

  findNodeById<T>(nodes: ITreeCategory<T>[], id: string): ITreeCategory<T> {
    for (const node of nodes) {
      if (node.id === id) {
        return node;
      } else if (node.items?.length > 0) {
        const foundNode = this.findNodeById<T>(node.items, id);
        if (foundNode) {
          return foundNode;
        }
      } else if (node.subCategories?.length > 0) {
        const foundNode = this.findNodeById<T>(node.subCategories, id);
        if (foundNode) {
          return foundNode;
        }
      }
    }
    return null;
  }
}

angular
  .module('flowingly.runner.services')
  .factory(
    'runnerCategoryNavigationService',
    () => new RunnerCategoryNavigationService()
  );

export type RunnerCategoryNavigationServiceType = InstanceType<
  typeof RunnerCategoryNavigationService
>;
